import React, { useState } from "react";
import { FaCheck, FaTimes, FaChevronDown, FaUndo } from "react-icons/fa";

export default function ShiftApplicationsPopup({ visible, onClose }) {
  const [openShiftId, setOpenShiftId] = useState(null);

  const [shifts, setShifts] = useState([
    {
      _id: "1",
      projectName: "Bygge A",
      date: "2026-02-20",
      startTime: "08:00",
      endTime: "16:00",
      openSpots: 2,
      approved: [],
      applications: [
        { _id: "a1", name: "Anna Andersson" },
        { _id: "a2", name: "Erik Karlsson" },
        { _id: "a3", name: "Sara Nilsson" },
      ],
    },
    {
      _id: "2",
      projectName: "Lager",
      date: "2026-02-21",
      startTime: "07:00",
      endTime: "15:00",
      openSpots: 1,
      approved: [],
      applications: [
        { _id: "a4", name: "Johan Berg" },
        { _id: "a5", name: "Maria Lund" },
      ],
    },
  ]);

  if (!visible) return null;

  // Godkänn
  const approve = (shiftId, app) => {
    setShifts(prev =>
      prev.map(s => {
        if (s._id !== shiftId) return s;
        if (s.approved.length >= s.openSpots) return s;
        return {
          ...s,
          approved: [...s.approved, app],
          applications: s.applications.filter(a => a._id !== app._id),
        };
      })
    );
  };

  // Ångra godkännande
  const undoApprove = (shiftId, person) => {
    setShifts(prev =>
      prev.map(s =>
        s._id === shiftId
          ? {
              ...s,
              approved: s.approved.filter(a => a._id !== person._id),
              applications: [...s.applications, person],
            }
          : s
      )
    );
  };

  // Neka
  const reject = (shiftId, appId) => {
    setShifts(prev =>
      prev.map(s =>
        s._id === shiftId
          ? { ...s, applications: s.applications.filter(a => a._id !== appId) }
          : s
      )
    );
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.4)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:9999 }}>
      <div style={{ width:900, background:"#fff", borderRadius:10, boxShadow:"0 8px 24px rgba(0,0,0,0.2)", padding:20, maxHeight:"80vh", display:"flex", flexDirection:"column", height: "60VH" }}>
        
        {/* Header */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
          <h2 style={{ margin:0, fontSize:18 }}>Ansökningar till pass</h2>
          <FaTimes onClick={onClose} style={{ cursor:"pointer", color:"#666" }} size={18} />
        </div>

        {/* Scroll area */}
        <div style={{ overflowY:"auto" }}>
          {shifts.map(shift => {
            const isOpen = openShiftId === shift._id;
            const isFull = shift.approved.length >= shift.openSpots;
            const totalApplicants = shift.applications.length + shift.approved.length;

            return (
              <div key={shift._id} style={{ borderBottom:"1px solid #eee", padding:"8px 0" }}>
                
                {/* Passrad */}
                <div
                  onClick={() => setOpenShiftId(isOpen ? null : shift._id)}
                  style={{
                    display:"grid",
                    gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr 40px",
                    alignItems:"center",
                    cursor:"pointer",
                    fontSize:14,
                  }}
                >
                  <strong>{shift.projectName}</strong>
                  <span>{shift.date}</span>
                  <span>{shift.startTime}-{shift.endTime}</span>
                  <span>Söker {shift.openSpots}</span>
                  <span>{totalApplicants} ansökningar</span>
                  <FaChevronDown style={{ transform:isOpen ? "rotate(180deg)" : "rotate(0)" }} />
                </div>

                {/* Innehåll */}
                {isOpen && (
                  <div style={{ marginTop:8 }}>
                    
                    {/* Godkända */}
                    {shift.approved.map(p => (
                      <div key={p._id} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0" }}>
                        <span>{p.name} <strong style={{ color:"#16a34a" }}>(Vald)</strong></span>
                        <FaUndo
                          size={14}
                          style={{ cursor:"pointer", color:"#888" }}
                          title="Ångra"
                          onClick={() => undoApprove(shift._id, p)}
                        />
                      </div>
                    ))}

                    {/* Ansökningar */}
                    {shift.applications.map(app => {
                      const reserve = isFull;

                      return (
                        <div key={app._id} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", alignItems:"center" }}>
                          <span>
                            {app.name} {reserve && <strong style={{ color:"#999" }}>(Reserv)</strong>}
                          </span>

                          <div style={{ display:"flex", gap:10 }}>
                            <FaCheck
                              size={16}
                              style={{
                                cursor: reserve ? "not-allowed" : "pointer",
                                color: reserve ? "#ccc" : "#5DADE2",
                              }}
                              onClick={() => !reserve && approve(shift._id, app)}
                              title={reserve ? "Fullt" : "Godkänn"}
                            />
                            <FaTimes
                              size={16}
                              style={{ cursor:"pointer", color:"#888" }}
                              onClick={() => reject(shift._id, app._id)}
                              title="Neka"
                            />
                          </div>
                        </div>
                      );
                    })}

                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
